import { render, staticRenderFns } from "./mcrFooter.vue?vue&type=template&id=36f80ac6&scoped=true"
import script from "./mcrFooter.vue?vue&type=script&lang=js"
export * from "./mcrFooter.vue?vue&type=script&lang=js"
import style0 from "./mcrFooter.vue?vue&type=style&index=0&id=36f80ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f80ac6",
  null
  
)

export default component.exports